import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { ROUTES } from "utils/constants";

import { useSubscriptionContext } from "context/Subscription";

export default function useIsActive() {
  const navigate = useNavigate();

  const { subscription, isActive } = useSubscriptionContext();

  useEffect(() => {
    if (subscription && isActive === false) {
      navigate(ROUTES.HOME);
    }
  }, [subscription, isActive, navigate]);
}
